// extracted by css-extract-rspack-plugin
export default {"wrapperInner":"ManagementAndCosts_wrapperInner__OG3aq","root":"ManagementAndCosts_root__xPsXM","collapseContainer":"ManagementAndCosts_collapseContainer__nCPku"};